import { render, staticRenderFns } from "./AllCompanies.vue?vue&type=template&id=385a51a6"
import script from "./AllCompanies.vue?vue&type=script&lang=js"
export * from "./AllCompanies.vue?vue&type=script&lang=js"
import style0 from "./AllCompanies.vue?vue&type=style&index=0&id=385a51a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports